import { createAsyncThunk } from "@reduxjs/toolkit";
import { setOtpRecords } from "store/features/otpRecord/otpRecordSlice";
import {
  getOtpRecords,
  toggleOtpRecord,
} from "store/features/api/otpRecordApi/otpRecordApi";

import { showErrorNotification } from "../../notification/notificationSlice";

export const getOtpRecordsThunk = createAsyncThunk(
  "thunkSlice/getOtpRecordsThunk",
  async (_, { dispatch }) => {
    try {
      const response = await dispatch(
        getOtpRecords.initiate({}, { forceRefetch: true }),
      ).unwrap();
      dispatch(setOtpRecords(response));
    } catch (error: any) {
      dispatch(
        showErrorNotification({
          message: error?.data?.message ?? error?.data?.error,
        }),
      );
      console.error(error);
    }
  },
);

export const toggleOtpRecordThunk = createAsyncThunk(
  "thunkSlice/toggleOtpRecordThunk",
  async ({ id, isShared }: { id: string; isShared: boolean }, { dispatch }) => {
    try {
      const response = await dispatch(
        toggleOtpRecord.initiate({ id, isShared }),
      ).unwrap();
      dispatch(setOtpRecords(response));
    } catch (error: any) {
      dispatch(
        showErrorNotification({
          message: error?.data?.message ?? error?.data?.error,
        }),
      );
      console.error(error);
    }
  },
);
